//================== Bundle card change event for PDP ==================//

class BundleCardHandler {
  constructor() {
    this.bundleCards = document.querySelectorAll('.bundle-card');
    this.init();
    // On load, show the first bundle card
    if (this.bundleCards.length > 0) {
      this.handleCardClick(this.bundleCards[0]);
    }
  }

  init() {
    this.bundleCards.forEach(card => {
      card.addEventListener('click', () => this.handleCardClick(card));
    });
  }

  handleCardClick(selectedCard) {
    this.bundleCards.forEach(card => card.classList.remove('selected'));
    selectedCard.classList.add('selected');

    const priceElement = document.querySelector('.product .f-price__regular .f-price-item--regular');
    if (!priceElement) return;
    
    const basePrice = parseFloat(priceElement.dataset.price);
    const quantityElement = selectedCard.querySelector('.bundle-quantity');
    const discountElement = selectedCard.querySelector('.bundle-discount');
    const discountPriceElement = selectedCard.querySelector('.discount-price');
    const quantity = quantityElement ? parseInt(quantityElement.dataset.bundleQuantity) : 1;
    const discount = discountElement ? parseFloat(discountElement.dataset.bundleDiscount) : 0;

    let totalPrice = basePrice * quantity;
    let discountedPrice = totalPrice;
    
    if (discountPriceElement) {
      const discountPriceText = discountPriceElement.textContent.trim();
      if (discountPriceText) {
        const discountPriceNumber = parseFloat(discountPriceText.replace(',', '.'));
        discountedPrice = discountPriceNumber;

        // Add price-del class to regular price
        priceElement.classList.add('price-del');

        // Show original price as strikethrough
        const discountedPriceElement = document.querySelector('.price__regular.discounted_price');
        if (discountedPriceElement) {
          const originalPriceFormatted = (basePrice * quantity).toFixed(2).replace('.', ',');
          discountedPriceElement.textContent = '€' + discountedPrice.toFixed(2).replace('.', ',');
        }

        // Show discounted price as main price
        priceElement.textContent = '€' + discountPriceNumber.toFixed(2).replace('.', ',');
      }
    } else if (discount > 0) {
      const discountAmount = (totalPrice * discount) / 100;
      discountedPrice = totalPrice - discountAmount;
      
      // Add price-del class to regular price
      priceElement.classList.add('price-del');
      
      // Update discounted price element
      const discountedPriceElement = document.querySelector('.price__regular.discounted_price');
      if (discountedPriceElement) {
        const formattedDiscountedPrice = discountedPrice.toFixed(2).replace('.', ',');
        discountedPriceElement.textContent = '€' + formattedDiscountedPrice;
      }
    } else {
      // Remove price-del class if no discount
      priceElement.classList.remove('price-del');
      
      // Clear discounted price if no discount
      const discountedPriceElement = document.querySelector('.price__regular.discounted_price');
      if (discountedPriceElement) {
        discountedPriceElement.textContent = '';
      }
    }

    const formattedPrice = totalPrice.toFixed(2);
    const priceFormated = formattedPrice.replace('.', ',');
    priceElement.textContent = '€' + priceFormated;

    const variantElement = document.querySelector('.variant-label');
    const currentVariant = selectedCard.querySelector('.bundle-weight').textContent;
    if (variantElement) {
      variantElement.textContent = currentVariant;
    }

    const quantityInput = document.querySelector('.quantity__input');
    if (quantityInput) {
      quantityInput.value = quantity;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BundleCardHandler();
});


(function () {
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail.type === 'submit' && e.detail.formId === 'SvcrER') {
      setTimeout(() => {
        const form = document.querySelector('[data-testid="klaviyo-form-SvcrER"]');
        if (form) {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
    }
  });
})();